import { type ReactNode } from 'react';
import { Icon, type IconName } from './Icon.js';
import { cx } from './utils.js';

export function Stat(props: {
  label: string;
  value: ReactNode;
  hint?: string | undefined;
  accent?: boolean | undefined;
  icon?: IconName | undefined;
  /** 0–100. Renders the plan-usage bar from a real ratio. */
  meter?: number | undefined;
}) {
  const meter =
    typeof props.meter === 'number' ? Math.min(100, Math.max(0, props.meter)) : undefined;
  return (
    <div className="rounded-[var(--admin-radius,0.625rem)] border border-[color:var(--admin-border,#d8dee6)] bg-[color:var(--admin-surface,#fff)] p-5 shadow-[var(--admin-shadow-sm)] dark:border-slate-700 dark:bg-slate-900">
      <div className="flex items-start justify-between gap-3">
        <p className="admin-mono text-[10px] font-medium tracking-[0.14em] text-slate-500 uppercase dark:text-slate-400">
          {props.label}
        </p>
        {props.icon ? (
          <span className="grid size-8 shrink-0 place-items-center rounded-[var(--admin-radius-sm)] border border-[color:var(--admin-border)] text-[color:var(--admin-accent,#2563EB)] dark:border-slate-700">
            <Icon name={props.icon} className="size-3.5" />
          </span>
        ) : null}
      </div>
      <p
        className={cx(
          'admin-mono mt-3 text-2xl font-semibold tracking-tight',
          props.accent
            ? 'text-[color:var(--admin-accent,#2563EB)]'
            : 'text-slate-900 dark:text-slate-100',
        )}
      >
        {props.value}
      </p>
      {meter !== undefined ? (
        <div className="mt-3 h-1 overflow-hidden rounded-sm bg-slate-100 dark:bg-slate-800">
          <div
            className="h-full bg-[color:var(--admin-accent,#2563EB)] transition-[width] duration-300"
            style={{ width: `${meter}%` }}
          />
        </div>
      ) : null}
      {props.hint ? (
        <p className="mt-2 text-xs leading-relaxed text-slate-500 dark:text-slate-400">{props.hint}</p>
      ) : null}
    </div>
  );
}
